import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "b--sprite",
  "use": "b--sprite-usage",
  "viewBox": "0 0 72 31",
  "content": "<symbol viewBox=\"0 0 72 31\" xmlns=\"http://www.w3.org/2000/svg\" id=\"b--sprite\">\n<circle cx=\"15.5\" cy=\"15.5\" r=\"15.5\" />\n<circle cx=\"56.5\" cy=\"15.5\" r=\"15.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol